import React, {useEffect} from 'react';
import './styles/errorModal.scss';
import {useKeyPress} from '../../../utils/hooks/useKeyPress';

interface ErrorModalProps {
    isOpen: boolean;
    setIsOpen?: (isOpen: boolean) => void;
    className?: string;
    children: React.ReactNode;
    overlayClassName?: string;
    contentsClassName?: string;
}

function ErrorModalWrapper({
    className,
    children,
    isOpen,
    overlayClassName,
    contentsClassName,
    setIsOpen,
}: ErrorModalProps): JSX.Element | null {
    const isEscPressed = useKeyPress('Escape');
    useEffect(() => {
        if (isEscPressed && isOpen && setIsOpen) setIsOpen(false);
    }, [isEscPressed, setIsOpen, isOpen]);

    if (!isOpen) return null;

    return (
        <div className={`${className || 'c-errorModal'} ${isOpen ? 'c-errorModal__isOpen' : ''}`}>
            <div className={`${overlayClassName || 'c-errorModal__overlay'}`}>
                <div className={`${contentsClassName || 'c-errorModal__contents'}`}>{children}</div>
            </div>
        </div>
    );
}

export default ErrorModalWrapper;
